import(/* webpackMode: "eager" */ "/vercel/path0/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["AdBlockDialog"] */ "/vercel/path0/components/ads/AdBlockDialog.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AdSenseScript"] */ "/vercel/path0/components/ads/AdSenseScript.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AnalyticsAutopilot"] */ "/vercel/path0/components/analytics/AnalyticsAutopilot.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ConsentBanner"] */ "/vercel/path0/components/analytics/ConsentBanner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AppDownloadBanner"] */ "/vercel/path0/components/layout/AppDownloadBanner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AppPromptSheet"] */ "/vercel/path0/components/layout/AppPromptSheet.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Header"] */ "/vercel/path0/components/layout/Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PreloadDesktopBackground"] */ "/vercel/path0/components/layout/PreloadDesktopBackground.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CountryProbe"] */ "/vercel/path0/components/location/CountryProbe.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PageProgressBar"] */ "/vercel/path0/components/ui/PageProgressBar.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@16.3.8_@babel+core@7.29.7_@opentelemetry+api@1.9.1_@playwright+test@1.59.1_@types+node@2_ydxhzva44pdhw6z7bqbib3xgui/node_modules/next/font/google/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"Roboto\",\"arguments\":[{\"variable\":\"--font-roboto\",\"subsets\":[\"latin\"],\"weight\":[\"400\",\"500\",\"700\"],\"display\":\"swap\",\"preload\":false}],\"variableName\":\"roboto\"}");
